import React from 'react'


import {
  TagComponent,
  Avatar,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  array,
  number,
  shape,
  string,
} from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import StarsRating from 'Pods/Shared/StarsRating'

import { buildLocalizedPath } from 'Utils/getLocalizedUrl'
import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function DesignerInfo({
  keywords = EMPTY_ARRAY,
  user,
  totalModelText = 'model',
}) {
  const {
    username,
    avatar,
    rating,
    totalModels,
  } = user

  return (
    <div className="card-3d-model__article designer-promotions-card" id="featured-designer-promotion-card">
      <div className="designer-promotions-card__top">
        <Avatar
          size="64"
          username={username}
          isClickable
          img={avatar}
          onClick={() => {
            window.location = `/designers/${username}`
          }}
          id="featured-designer-avatar"
          data-track-name="featured-designer-avatar"
          color="brand-primary-100"
        />
        <a
          data-track-name="featured-designer-username"
          href={`/designers/${username}`}
          className="cgt-legacy-link designer-promotions-card__username"
          id="featured-designer-username"
        >
          {username}
        </a>

        {rating > 0 && (
          <div className="designer-promotions-card__rating cgt-legacy-text-default">
            <StarsRating rating={rating} readonly />
            <span className="designer-promotions-card__rating-number">
              {rating.toFixed(1)}
            </span>
          </div>
        )}

        {totalModels && (
          <div className="designer-promotions-card__models cgt-legacy-text-default">
            <Icon type={['far', 'cube']} className="user-data__counters-icon" notSpaced />
            {totalModels} {totalModelText}
          </div>
        )}
      </div>
      <div className="designer-promotions-card__bottom">
        <div className="designer-promotions-card__tags">
          {keywords
            .map((tag, index) => (
              <TagComponent
                hasBorder
                className="cgt-tag--clickable js-track-featured-designer-tag"
                type="ghost"
                key={index}
                data-track-name="featured-designer-tag"
                onClick={() => {
                  window.location = buildLocalizedPath(`/search?keywords=${tag}&author=${username}`)
                }}
              >
                {tag}
              </TagComponent>
            ))}
        </div>
      </div>
    </div>
  )
}

DesignerInfo.propTypes = {
  keywords: array,
  user: shape({
    username: string,
    avatar: string,
    rating: number,
    totalModels: number,
  }).isRequired,
  totalModelText: string,
}

export default DesignerInfo
